import React, { useEffect, useRef, createElement } from 'react';
import { motion } from 'framer-motion';
const HeroSection = () => {
  const typeformRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Set hidden fields from URL parameters
    if (typeformRef.current) {
      const params = new URLSearchParams(window.location.search);
      const hidden = ['fbclid=' + (params.get('fbclid') || ''), 'utm_source=' + (params.get('utm_source') || ''), 'utm_medium=' + (params.get('utm_medium') || ''), 'utm_campaign=' + (params.get('utm_campaign') || ''), 'utm_content=' + (params.get('utm_content') || ''), 'utm_term=' + (params.get('utm_term') || '')].join(',');
      typeformRef.current.setAttribute('data-tf-hidden', hidden);
    }
    // Ensure Typeform script is loaded
    const existingScript = document.querySelector('script[src*="typeform.com"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = '//embed.typeform.com/next/embed.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  return <section className="relative w-full bg-black min-h-[100dvh] py-6 sm:py-12 overflow-hidden" data-id="element-107">
      {/* Animated Gradient Background */}
      <div className="absolute inset-0 w-full h-full z-0 overflow-hidden" data-id="element-108">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a0a0a] via-[#0f0f0a] to-[#000000] animate-gradient-shift" data-id="element-109">
          <div className="absolute inset-0 opacity-30" data-id="element-110">
            <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_#ffdf07_0%,_transparent_60%)] animate-float-light-1" data-id="element-111"></div>
            <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(ellipse_at_bottom_left,_#D4AF37_0%,_transparent_60%)] animate-float-light-2" data-id="element-112"></div>
            <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-113"></div>
          </div>
        </div>
        <div className="absolute inset-0 bg-black bg-opacity-40 z-10" data-id="element-114"></div>
      </div>
      {/* Content */}
      <div className="relative z-20 w-full mx-auto py-4 sm:py-8 px-3 sm:px-6 md:px-8 flex flex-col justify-center min-h-[90dvh]" data-id="element-115">
        <div className="max-w-4xl mx-auto text-center" data-id="element-116">
          {/* Logo */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} className="mb-4 sm:mb-6" data-id="element-117">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iEuzHiZoD7HHWbnpRvvh2M/516lion.png" alt="516 Partners Logo" className="mx-auto w-20 sm:w-28 md:w-32" data-id="element-118" />
          </motion.div>
          {/* Small Headline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="text-[#ffdf07] text-sm sm:text-lg md:text-xl font-semibold mb-3 sm:mb-4 tracking-wide font-['Inter',sans-serif]" data-id="element-119">
            For Private Healthcare Clinics Doing $500K–$5M/Yr…
          </motion.p>
          {/* Main Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} className="text-white text-[1.62rem] sm:text-[2.6rem] md:text-[2.8rem] lg:text-[3rem] xl:text-[3.2rem] mb-4 sm:mb-6 typekit-heading leading-[1.1] px-1 sm:px-2" data-id="element-120">
            We Guarantee to Unlock $50K-$250K in Lost Revenue in{' '}
            <span className="relative inline-block" data-id="element-121">
              <span className="relative z-10 px-1.5 sm:px-3 text-black font-bold text-[1.62rem] sm:text-[2.6rem] md:text-[2.8rem] lg:text-[3rem] xl:text-[3.2rem]" data-id="element-122">
                30 Days or Less
              </span>
              <motion.span initial={{
              scaleX: 0
            }} animate={{
              scaleX: 1
            }} transition={{
              duration: 0.8,
              delay: 0.3,
              ease: 'easeOut'
            }} style={{
              transformOrigin: 'left'
            }} className="absolute inset-0 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] rounded-md shadow-[0_4px_14px_rgba(255,223,7,0.25)] z-0" data-id="element-123" />
            </span>{' '}
            Without Seeing More Patients, Cutting Staff, Or Burning $$$ on
            Agencies
          </motion.h1>
          {/* Subheadline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.4
        }} className="libre-caslon-text-regular text-sm sm:text-lg text-white mb-5 sm:mb-8 leading-relaxed px-1 sm:px-2" data-id="element-124">
            Step 1: Watch the video below to learn how we help providers become
            insanely profitable
          </motion.p>
          {/* Wistia Video Player - New Video */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.6
        }} className="w-full max-w-[95%] sm:max-w-md md:max-w-xl lg:max-w-3xl mx-auto mb-5 sm:mb-8" data-id="element-125">
            <div className="relative shadow-2xl rounded-lg overflow-hidden" data-id="element-126">
              <wistia-player media-id="me9xxd1792" aspect="1.7777777777777777" data-id="element-127"></wistia-player>
            </div>
          </motion.div>
          {/* Step 2 Text */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.7
        }} className="mb-4 sm:mb-6" data-id="element-128">
            <p className="libre-caslon-text-regular text-sm sm:text-lg text-white leading-relaxed px-1 sm:px-2" data-id="element-129">
              Step 2: Secure Your $50K-$250K Plan (Application may take a bit to
              load)
            </p>
          </motion.div>
          {/* Embedded Typeform with UTM tracking */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.8
        }} className="w-full max-w-2xl mx-auto mb-4" id="typeform-section" data-id="element-130">
            <div id="tf-embed" ref={typeformRef} data-tf-live="01KGGG8GH6HJQ1EP0BD77W491R" style={{
            width: '100%',
            minHeight: '400px'
          }} data-id="element-131"></div>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default HeroSection;